import React from "react";
import ReactDOM from 'react-dom';

const PickerWidget = window.auiEmbeddableWidgets.reactComponent(
  // url to the definition
  'https://locationwidgets.antwerpen.be/definitions/location-picker-v2.json',
  { React, ReactDOM }
)
const url = "https://geoint.antwerpen.be/arcgissql/rest/services/P_DA/Locaties_Cascade/MapServer";
const PickerWrapper = (props) => {
  return <>
    <PickerWidget
      className={`map-widget ${props.className}`}
      onLocationSelect = {props.onWhatIsHereSelected}
      showLayerManagement = {true}
      showSelectionTools = {true}
      showMeasureTools = {false}
      showWhatIsHereButton = {false}
      cascadingCoordinateRules = {[
        {
          type: 'location',
          locationOptions: {
            mapService: url,
            layerIds: '5',
            returnGeometry: true,
            tolerance: 1,
            count: 1,
          },
        },
        {
          type: 'address',
          addressOptions: {
            buffer: 25,
            count: 3,
            relevance: true,
          },
        },
        {
          type: 'location',
          locationOptions: {
            mapService: url,
            layerIds: '4',
            returnGeometry: true,
            tolerance: 1,
            count: 3,
            buffer: 20,
          },
        },
        {
          type: 'address',
          addressOptions: {
            buffer: 100,
            count: 3,
            relevance: true,
          },
        },
        {
          type: 'location',
          locationOptions: {
            mapService: url,
            layerIds: '2',
            returnGeometry: true,
            tolerance: 1,
            count: 3,
            buffer: 100,
          },
        },
      ]}
    />
  </>;
}

export default PickerWrapper;
